import { render, staticRenderFns } from "./Coords.vue?vue&type=template&id=70e8e036"
import script from "./Coords.vue?vue&type=script&lang=js"
export * from "./Coords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports